<template>  
  <div class="sellservice">
    <XR-head titleText="售后订单"></XR-head>
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
    <mu-tabs :value="activeTab" @change="handleTabChange" class="sellservice-tab">
      <mu-tab value="tab1" title="全部" titleClass="tab-item"/>
      <mu-tab value="tab2" title="待审核" titleClass="tab-item"/>
      <mu-tab value="tab3" title="待发货" titleClass="tab-item"/>
      <mu-tab value="tab4" title="待收货" titleClass="tab-item"/>
      <mu-tab value="tab5" title="待退款" titleClass="tab-item"/>
      <mu-tab value="tab6" title="已完成" titleClass="tab-item"/>
      <mu-tab value="tab7" title="已关闭" titleClass="tab-item"/>
    </mu-tabs>

      <div class="order-list">
        <div class="order-item" v-for="sellItem in sellServiceList" :key="sellItem.SellServiceNo">    
          <div class="ordertip">
            <p class="orderno">服务单号：{{sellItem.SellServiceNo}}</p>
            <p class="ordertype">{{sellItem.StateName}}</p>
          </div>
          <div class="hidden-scorll">
            <div class="suborder-item-list">
              <router-link :to="'/usercenter/sellservicedetail?sellServiceNo='+sellItem.SellServiceNo">
                <div class="suborder-item">
                  <img :src="sellItem.OrderItem.DetailImage?sellItem.OrderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                  <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">
                    <p class="product-name">{{sellItem.OrderItem.ProductName}}</p>
                    <p class="attr">{{sellItem.OrderItem.Attribute}}</p>          
                    <router-link v-if="sellItem.State==2" :to="'/usercenter/sellservicedelivery?sellServiceNo='+sellItem.SellServiceNo" class="item-button sellservice-request">发货</router-link>
                  </div>
              </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
  </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      activeTab: 'tab1',
      loaded: true,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      sellServiceList:[],
      sellServiceRequestList:[],
      requestPageIndex:0,
      requestPageEnd:0,
      pageIndex:1,
      pageEnd:0,
      num :15,
      scrollDone:function(){},
      state:0      
    }
  },
  mounted(){    
    var cacheVal = window.localStorage.SellServiceTypeCache
    if(!cacheVal){
      cacheVal = 'tab1'
    }

    this.handleTabChange(cacheVal)
  },
  methods: {
    handleTabChange (val) {
      this.activeTab = val
      window.localStorage.SellServiceTypeCache = val
      
      if(this.activeTab == 'tab1'){
        this.state= 0;
      }
      else if(this.activeTab == 'tab2'){
        this.state= 1;
      }
      else if(this.activeTab == 'tab3'){
        this.state= 2;
      }
      else if(this.activeTab == 'tab4'){
        this.state= 3;
      }
      else if(this.activeTab == 'tab5'){
        this.state= 9;
      }
      else if(this.activeTab == 'tab6'){
        this.state= 6;
      }
      else if(this.activeTab == 'tab7'){
        this.state= 8;
      }
      this.getSellServiceList(true)
    },
    getSellServiceList(isNewSearch){
      this.loaded = true
      this.$refs.XRtoast.load()
      if(isNewSearch){
        this.pageIndex= 1
      }
      else{
        this.pageIndex++
      }
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetSellServiceOrderPage",
        JSON.stringify({pageIndex:this.pageIndex, state: this.state})
      ).then(function(res) {
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){          
          if(isNewSearch){
            ths.sellServiceList = []
          }
          ths.$refs.XRtoast.hide()
        }else{    
          if(isNewSearch){
            ths.sellServiceList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.sellServiceList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num

          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
            
        if(ths.sellServiceList.length ==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },    
    getSellServiceRequestList(isNewSearch){
      this.loaded = true
      this.$refs.XRtoast.load()
      if(isNewSearch){
        this.requestPageIndex= 1
      }
      else{
        this.requestPageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetSellServiceOrderCanRequestPage",
        JSON.stringify({pageIndex:this.requestPageIndex})
      ).then(function(res) {
        
        if(!res.IsSuccess){          
          if(isNewSearch){
            ths.sellServiceRequestList = []           
          }
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          if(isNewSearch){
            ths.sellServiceRequestList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.sellServiceRequestList.push(res.Data.List[i])
            }
          }
          ths.requestPageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num

          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
        
        if(ths.sellServiceRequestList.length ==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.pageIndex+1 > this.pageEnd){  
        this.$refs.XRtoast.failed("已经到最后一页", true)
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getSellServiceList(false);   
    }
  }
}
</script>

<style>
.sellservice .xr-pageTip{
  top: 104px;
}
.sellservice .search-tab{
  overflow: hidden;
  height: 56px;
  line-height: 56px;
  background: white;
  padding: 0 20%;
}
.sellservice .search-tab .button{
  float: left;
  width: 50%;
  font-size: 12px;
  padding-left: 10px;
}
.sellservice .search-tab .button.request-button{
  text-align: right;
  padding-right: 10px;
}
.sellservice .search-tab .button.select{
  color:red;
}
.sellservice .sellservice-tab{
}
.sellservice .mu-tab-link .tab-item{
}


.sellservice .order-list{
  overflow: hidden;
}
.sellservice .order-item{
  background: white;
  margin: 10px 0 0;
}
.sellservice .ordertip{
  overflow: hidden;
  background: white;
  padding:0 10px;
  border-bottom:1px solid #eee;
}
.sellservice .ordertip .orderno{
  float: left;
  line-height: 48px;
  font-size: 12px;
}
.sellservice .ordertip .ordertime{
  float: right;
  line-height: 48px;
  font-size: 12px;
}
.sellservice .ordertip .ordertype{
  float: right;
  line-height: 48px;
  font-size: 12px;
}

.sellservice .suborder-item-list{
  overflow: hidden;
  padding: 0 10px;
  border-bottom:1px solid #eee;
}
.sellservice .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 15px 0;
}
.sellservice .suborder-item ~ .suborder-item{
  border-top:1px solid #eee;
}
.sellservice .suborder-item .order-img{
  width: 60px;
  height: 60px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
}
.sellservice .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
  height: 100px;
}
.sellservice .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  line-height: 18px;
  height: 36px;
  font-size: 12px;
  color:#333;
}
.sellservice .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 18px;
  font-size: 12px;
  color:#999;
  padding-top: 6px;
}
.sellservice .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  width: 60px;
  padding: 0;
  border: none;
  background: #f9f9f9;
  color:black;
  border:1px solid red;
  border-radius: 2px;
  margin-top: 12px;
  margin-left: 10px;
  text-align: center;
}
.sellservice .xr-pageTip {
    top: 104px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sellservicelist.vue